var render = function render(_c,_vm){return _c('path',{attrs:{"d":"M18 18H10V12H18V18ZM8 18H0V8H8V18ZM18 10H10V0H18V10ZM8 6H0V0H8V6Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }